define('viewModels/MyAccount',[
    'lib/knockout',
    'lib/lodash4',
    'lib/bluebird',
    'services/localeService',
    'services/routeService',
    'util/errorCallbackFactory',
    'viewModels/ViewModel',

    'extensions/i18n/knockout.i18n'
],
function (
    ko,
    _,
    Promise,
    localeService,
    routeService,
    errorCallbackFactory,
    ViewModel
) {
    'use strict';

    var supportedLocales = [
        'en-US',
        'es',
        'fr'
    ];

    function generateLocaleInfo(locale) {
        return {
            id: locale,
            name: ko.i18n.renderString('myAccount.locale.' + locale.toLowerCase(), locale)
        };
    }

    var MyAccount = ViewModel.extend(function () {
        var self = this;

        self.isLoadingLocales = ko.observable(true);
        self.isEditingLocale = ko.observable(false);
        self.isSavingLocale = ko.observable(false);
        self.localeOptions = ko.observableArray([]);
        self.selectedLocale = ko.observable();

        self.edit = function () {
            self.isEditingLocale(true);
        };

        self.cancelEdit = function () {
            detectActiveLocale();
            self.isEditingLocale(false);
        };

        self.saveLocale = function () {
            self.isSavingLocale(true);
            localeService.setUserLocale(self.selectedLocale().id)
                .catch(errorCallbackFactory.createCallback({namespace: 'myAccount.saveLocale'}))
                .finally(function () {
                    self.isSavingLocale(false);
                    self.isEditingLocale(false);
                });
        };

        self.searchLocales = function (text) {
            var localeOptions = self.localeOptions();
            if (text.length > 0) {
                localeOptions = _.filter(localeOptions, function (localeOption) {
                    return _.includes(localeOption.name.toLowerCase(), text.toLowerCase());
                });
            }
            return Promise.resolve(localeOptions);
        };

        function detectActiveLocale() {
            var selectedLocale = _.find(self.localeOptions(), {id: ko.i18n.getLocale()});
            if (!selectedLocale) {
                selectedLocale = {id: ko.i18n.getLocale(), name: ko.i18n.getLocale()};
            }
            self.selectedLocale(selectedLocale);
        }

        function init() {
            var localePromises = [];
            _.each(supportedLocales, function (locale) {
                localePromises.push(localeService.loadLocale(locale));
            });

            Promise.all(localePromises)
                .then(function () {
                    var localeInfo = _.map(supportedLocales, generateLocaleInfo);
                    self.localeOptions(localeInfo);
                    detectActiveLocale();
                })
                .finally(function () {
                    self.isLoadingLocales(false);
                });
        }

        init();
    });

    return MyAccount;
});

